export const tr = {
    'banner-archived': 'Reklamı arşive kaldırma',
    'banner-hide': 'Reklam durdurma',
    'banner-show': 'Reklam etkinleştirme',
    'banner-unarchived': 'Reklamı arşivden çıkarma',
    bannerNo: 'Reklam №',
    broadmatch: 'İlgili ek sözcük grupları',
    'campaign-archived': 'Kampanyayı arşive kaldırma',
    'campaign-creation': 'Kampanya oluştur',
    'campaign-hide': 'Kampanyayı durdur',
    'campaign-show': 'Kampanya başlatma',
    'campaign-unarchived': 'Kampanyayı arşivden çıkarma',
    campaignFinish: 'Kampanyanın bitiş tarihi',
    campaignStart: 'Kampanyanın başlangıç tarihi',
    changes: 'Değişiklik parametreleri',
    cid: 'Kampanya №',
    demography: 'Yaş ve cinsiyete göre teklif düzenleme',
    disabledDomains: 'Engelli siteler',
    disabledIps: 'Engelli IP adresleri',
    disabledSsp: 'Engelli harici ağlar',
    extendedGeo: 'Genişletilmiş coğrafi hedefleme',
    groupNo: 'Grup №',
    minusWords: 'Kampanya için negatif anahtar sözcük grupları',
    mobileMultipliers: 'Mobil için teklif düzenleme',
    network: 'Ağlarda ayarlar',
    objects: 'Objeler',
    perfomanceMultipliers: 'Akıllı reklamlar için teklif düzenleme',
    regions: 'Gösterim bölgesi',
    restrictFrequency: 'Gösterim sıklığının kısıtlanması',
    retargeting: 'Hedef kitle için teklif düzenleme',
    settings: 'Ayarlar',
    statuses: 'Durumlar',
    strategy: 'Strateji',
    timeTargeting: 'Zaman hedefleme',
    userName: 'Değiştiren',
    videoMultipliers: 'Video eklentiler için teklif düzenleme'
};
